import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { BRAND, NAV, SERVICES } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-[#1F3463]/95 backdrop-blur-md shadow-lg py-3"
          : "bg-[#1F3463] py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={BRAND.logoLight}
            alt="Boulter Group"
            className={`w-auto transition-all duration-300 ${
              scrolled ? "h-24" : "h-32"
            }`}
          />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((item) =>
            item.label === "Services" ? (
              <div
                key={item.to}
                className="relative"
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <NavLink
                  to={item.to}
                  className="flex items-center gap-1 text-sm font-semibold uppercase tracking-wide text-white/90 transition-colors hover:text-[#C9A876]"
                >
                  {item.label}
                  <ChevronDown className="h-4 w-4" />
                </NavLink>
                <div
                  className={`absolute left-1/2 top-full w-64 -translate-x-1/2 pt-4 transition-all duration-200 ${
                    servicesOpen
                      ? "visible opacity-100 translate-y-0"
                      : "invisible opacity-0 translate-y-2"
                  }`}
                >
                  <div className="overflow-hidden rounded-xl border border-black/5 bg-white py-2 shadow-2xl">
                    {SERVICES.map((s) => (
                      <Link
                        key={s.id}
                        to={`/services#${s.id}`}
                        className="block px-5 py-2.5 text-sm font-medium text-[#1F3463] transition-colors hover:bg-[#F5F1E8] hover:text-[#15264a]"
                      >
                        {s.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm font-semibold uppercase tracking-wide transition-colors hover:text-[#C9A876] ${
                    isActive ? "text-[#C9A876]" : "text-white/90"
                  }`
                }
              >
                {item.label}
              </NavLink>
            )
          )}
          <a
            href={BRAND.phoneHref}
            className="btn-gold flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-semibold"
          >
            <Phone className="h-4 w-4" />
            {BRAND.phone}
          </a>
        </nav>

        <button
          className="text-white lg:hidden"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`overflow-hidden transition-all duration-300 lg:hidden ${
          mobileOpen ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col gap-1 px-5 pb-6 pt-4">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-3 text-base font-semibold uppercase tracking-wide transition-colors ${
                  isActive
                    ? "bg-white/10 text-[#C9A876]"
                    : "text-white/90 hover:bg-white/5"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={BRAND.phoneHref}
            className="btn-gold mt-2 flex items-center justify-center gap-2 rounded-md px-4 py-3 text-base font-semibold"
          >
            <Phone className="h-4 w-4" />
            {BRAND.phone}
          </a>
        </nav>
      </div>
    </header>
  );
}
